import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import Navbar from './components/layout/Navbar';
import SubFooter from './components/layout/SubFooter';
import messages from './translations/messages';
import ScrollToTop from 'react-router-scroll-top';
import './App.css';

const Home = lazy(() => import('./components/Home'));
const QCInfo = lazy(() => import('./components/qualitycerts/QCInfo'));
const PositionStatment = lazy(() =>
  import('./components/positionstatements/PositionStatment')
);
const SdsInfo = lazy(() => import('./components/sds/SdsInfo'));
const QCSearchResults = lazy(() =>
  import('./components/qualitycerts/QCSearchResults')
);
const SDSSearch = lazy(() => import('./components/sds/SDSSearch'));
const SDSInternalSearch = lazy(() => import('./components/sds/SDSInternalSearch'));
const ContactUs = lazy(() => import('./components/contactus/ContactUs'));
const ContactUsResults = lazy(() =>
  import('./components/contactus/ContactUsResults')
);
const Resources = lazy(() => import('./components/pages/Resources'));
const FAQ = lazy(() => import('./components/pages/FAQ'));
const NotFound = lazy(() => import('./components/pages/NotFound'));

const ApplicationTree = (props) => {
  return (
    <Router basename={process.env.REACT_APP_ROUTER_BASE || ''}>
      <ScrollToTop>
        <IntlProvider messages={messages[props.locale]} locale={props.locale}>
          <div className="App">
            <Header />
            <Navbar />
            <Suspense
              fallback={
                <div className="align-center" style={{ background: '#fff' }}>
                  Loading...
                </div>
              }
            >
              <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/qcinfo" component={QCInfo} />
                <Route
                  exact
                  path="/qcSearchResults"
                  component={QCSearchResults}
                />
                <Route
                  exact
                  path="/positionstatement"
                  component={PositionStatment}
                />
                <Route exact path="/sdsInfo" component={SdsInfo} />
                <Route exact path="/sdsSearch" component={SDSSearch} />
                <Route 
                  exact
                  path="/sdsInternalSearch"
                  component={SDSInternalSearch}
                />
                <Route exact path="/resources" component={Resources} />
                <Route exact path="/faqs" component={FAQ} />
                <Route exact path="/contactus" component={ContactUs} />
                <Route
                  exact
                  path="/contactus/:material"
                  component={ContactUsResults}
                />
                <Route component={NotFound} />
              </Switch>
            </Suspense>
            <SubFooter />
            <Footer />
          </div>
        </IntlProvider>
      </ScrollToTop>
    </Router>
  );
};

ApplicationTree.propTypes = {
  locale: PropTypes.string,
};

ApplicationTree.defaultProps = {
  locale: 'en',
};

const mapStateToProps = (state) => {
  return {
    locale: state.localeReducer.locale.locale,
  };
};

export default connect(mapStateToProps)(ApplicationTree);
